import { useRhinoConfig } from '@rhino-project/core/config';
import {
  ErrorBoundary as RollbarErrorBoundary,
  Provider as RollbarProvider
} from '@rollbar/react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import FavIcon from './assets/images/favicon.png';
import { Helmet } from 'react-helmet';
import { RhinoProvider } from '@rhino-project/core';
import { BrowserRouter, Routes } from 'react-router-dom';
import { customRoutes } from './routes/custom';

const VisibleError = ({ error }: { error?: Error }) => (
  <div role="alert" style={{ padding: '2rem', color: '#7f1d1d', background: '#fef2f2' }}>
    <h1>Failed to render The Third Door</h1>
    <p>{error?.message ?? 'An unexpected frontend error occurred.'}</p>
  </div>
);

const Root = () => {
  const {
    appName,
    env: { ROLLBAR_ACCESS_TOKEN, ROLLBAR_ENV, ROLLBAR_ENABLED }
  } = useRhinoConfig();
  const rollbarConfig = {
    accessToken: ROLLBAR_ACCESS_TOKEN,
    environment: ROLLBAR_ENV,
    enabled: ROLLBAR_ENABLED,
    captureUncaught: true,
    captureUnhandledRejections: true
  };

  return (
    <RhinoProvider>
      <RollbarProvider config={rollbarConfig}>
        <RollbarErrorBoundary fallbackUI={({ error }) => <VisibleError error={error} />}>
          <ReactQueryDevtools
            initialIsOpen={false}
            buttonPosition="bottom-right"
            position="bottom"
          />
          <Helmet>
            <title>{appName}</title>
            <link rel="icon" type="image/png" sizes="16x16" href={FavIcon} />
          </Helmet>
          <BrowserRouter>
            <Routes>{customRoutes()}</Routes>
          </BrowserRouter>
        </RollbarErrorBoundary>
      </RollbarProvider>
    </RhinoProvider>
  );
};

export default Root;
